/* eslint-disable max-len */
import { setIsModalOpen } from './actions';

export const OTP_PAYMENT_STATUSES = {
  desktop: {
    Scheduled_Payment_Accepted: {
      linkLabel: 'Cancel Payment',
      text: 'A one-time payment of {{pendingPaymentTotal}} is scheduled for {{pendingScheduledDate}}.',
    },
    Scheduled_Payment_Not_Eligible: { text: 'At this time you cannot make online payments. Please contact us at {{customerServicePhoneNumber}}' },
    Scheduled_Payment_Processing: { text: 'A one-time payment of {{pendingPaymentTotal}} is scheduled for {{pendingScheduledDate}}. The deadline to cancel this payment has passed.' },
  },
  mobile: {
    Scheduled_Payment_Accepted: {
      button: {
        label: 'Cancel Payment',
        operation: setIsModalOpen,
        operationResponse: { key: 'cancel', value: true },
      },
      text: 'A one-time payment of {{pendingPaymentTotal}} is scheduled for {{pendingScheduledDate}}.',
    },
    Scheduled_Payment_Not_Eligible: { text: 'At this time you cannot make online payments. Please contact us at {{customerServicePhoneNumber}}' },
    Scheduled_Payment_Processing: { text: 'A one-time payment of {{pendingPaymentTotal}} is scheduled for {{pendingScheduledDate}}. The deadline to cancel this payment has passed.' },
  },
};
